// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vS0We","colBig":"styles_colBig__1woBu","colSmall":"styles_colSmall__1Z1Hd","shopifyNameWrapper":"styles_shopifyNameWrapper__1hFEZ"};